import Vue from 'vue';
import Vuex from 'vuex';
import apiAuthenticationPlugin from './plugins/api.authentication';
import apiLoadingPlugin from './plugins/api.loading';
import apiErrorPlugin from './plugins/api.error';
import alerts from './modules/alerts';
import loading from './modules/loading';
import user from './modules/user';
import member from './modules/member';
import employer from './modules/employer';
import localization from './modules/localization';
import activityArea from './modules/activityArea';
import menu from './modules/menu';
import timeEntry from './modules/timeEntry';
import expense from './modules/expense';
import attachedFile from './modules/attachedFile';
import calendar from './modules/calendar';
import informationPage from './modules/informationPage';
import contactUs from './modules/contactUs';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [apiAuthenticationPlugin, apiErrorPlugin, apiLoadingPlugin],
  modules: {
    alerts,
    loading,
    user,
    member,
    employer,
    localization,
    activityArea,
    menu,
    timeEntry,
    expense,
    attachedFile,
    calendar,
    informationPage,
    contactUs,
  },
});
